import React from "react";
import "./App.css";

class App extends React.Component {
  state = { advice: "" };

  componentDidMount() {
    this.fetchAdvice();
  }

  fetchAdvice = () => {
    const quotes = [
      "ชวนฟานงิไปด้วย เอาห้องรวม แล้วแทงตูดกันเองให้ผญดู",
      "หีหนึบๆ อะ กูไม่ต้องการอะไรอีกละ",
      "เอาควยเบียดต้นขาก็มีความสุขแล้ว",
      "อยากเอาควยแทงปากหมอฟัน",
      "ให้เค้ารู้ไปเลย ว่าชี้ฟ้า ไม่ได้มีแค่พริก",
      "ถ้าไม่ให้เชียร์เบียร์ แล้วจะให้เชียร์เมียรึไง",
      "อยากลูบไล้ละลาบโลมเลียหี",
      "จะไปก็ไป แต่รักกว่ากูคงไม่มีละ",
      "อมเม็นทอสละเลียหีอร่อยที่สุด",
      "ผมเป็นเครื่องจักรเปลี่ยนคำรักให้เป็นบทกวี",
      "ลิเบอรัลแค่ไหนถึงจะรับได้ตอนที่รู้ว่าคนที่เราเย็ดไปอมควยคนอื่นมาแล้ว",
      "อย่างที่ว่า หนึ่งปีสองปี มันยังไม่ทันได้เก็บดอกผลหรอก ผลลัพธ์ของความรัก มันไม่ได้สั้นขนาดนั้น",
      "ความสัมพันธ์มันก็เหมือนปลูกพืชซักต้นนึงอะ มันอาจจะตายเพราะอายุของมันหมดแล้ว หลักเดือน หลักปี หลักสิบปี หรือเพราะขาดการดูแล แต่ใดๆ นั้น มันต้องการความใส่ใจในกันและกันเสมอ",
      "ดูๆ ไปเถอะ หนังก็คือหนัง ไม่ใช่เลคเชอร์",
      "มือที่จับชักว่าวแล้วมาจับมือเรา เราก็ยังยอม เพราะคไว่ารักคำเดียวยังไงล่ะ",
      "โถอีสัส เลิดหวีดผู้เกาแล้วจะเล่าให้ฟังนะ",
      "ถ้าเป็นเงินไทยก็แพงดิ กะหรี่ไทยถูกและดีที่สุดในโลก พวกไม่ยอมซื้อบริการเนี่ยโง่เต็มทน",
      "ไอดอลเดี๋ยวก็แก่ แต่งงานมีวัว อะไรก็ไม่เที่ยงทั้งนั้น มีแต่ดอกเบี้ยที่สม่ำเสมอ",
      "ใครเห็นต่าง ให้ถ่างหอย",
      "ความไร้ระเบียบบ่งชี้ถึงวินัยในการใช้ชีวิตคนนั้นๆ เหมือนกัน",
      "เรื่องโม่ยไอดอลน่ะ กูว่าไร้สาระ",
      "เบื่อแล้วซับไทยอยากดูซับในลูกสาวคนขายผัดไทย",
      "เวลาแปลงเป็นได้ทุกอย่าง ความสัมพันธ์ เงิน บารมี",
      "เบื่อแล้ว side quest เลาเองอยาก side core",
      "ความรักที่ผ่านพ้นไป มีแต่คำว่าเสียดาย แต่ไม่มีคำว่าเสียใจ",
      "กูเคยโดนยุงกัดยังไม่เห็นกัดยุงคืนเลย การให้อภัยคือการให้ที่ยิ่งใหญ่ที่สุด จำไว้นะ",
      "ดีนะที่ยังเย็ดท่อไอเสียรถได้",
      "ในทางการเงินกูแพ้แล้วตอนนี้ แต่ในทางใจกูทำให้ใจสลายได้",
      "อยากเย็ดตูดโม่ง",
      "จู๋สร้างมาไว้ใช้กับจิ๋ม ไม่ใช่ก้น",
      "ในวันนั้นกูขับรถหันหลังกลับไป พร้อมเพลงโพลีแคท แถมการกระจัดระหว่างสองเราห่างขึ้นเรื่อยๆ โดยไม่มีความเสียดายในใจซักนิดเดียว",
      "ก็แค่ชายธรรมดาคนนึงที่ถือแดรี่ควีนคว่ำถ้วย ไม่ได้พิเศษอะไร",
      "กูยอมนอนพื้นเย็นๆ ที่ยังอบอุ่นกว่าหัวใจคนเย็นชา",
      "ผู้ชายมันสกปรกยังไงก็สกปรก ล้างไม่ออกหรอก แม้แต่น้ำตาเด็กผู้หญิง",
      "พรวดเดียวไม่เป็นเกย์หรอก พิสูจน์ความเป็นชายของกู",
      "อาจจะเพราะความคิดชายเป็นใหญ่มาแทรกซึมทำให้อยากเลียแท่งแบบไม่รู้ตัว",
      "ไม่เป็นไร อย่างน้อยก็ได้ขยำตอนเธออ่อนไหวเพราะฤทธิ์แอลกอฮอล์",
      "ต้นถั่วบราซิลทุกต้นที่กูปลูกกูปลูกด้วยความเพียรมานะมาตลอด แม้จะมีบางต้นเหี่ยวแห้งลงไป แต่ก็ก็ทำได้แค่เสียใจ แต่ชีวิตมันต้องไปต่อว่ะ",
      "ตื่นดิ แค่คิดว่าถ้าพรุ่งนี้ตื่นสายก็อดชักว่าวก็เป็นแรงในการลุกขึ้นสู้ในวันต่อไปได้แล้วล่ะ",
      "มึงไม่เคยซอยไปอ่านดิสไปหรอ",
      "ศึกษาไอดอลเช่นศึกษาธรรม มาพร้อมกันบางคนก็กลายเป็นกาจิโค่ย บางคนก็เป็นแอนตี้ บางคนก็เป็นพวกคิโม่ย ทั้งที่ตอนเริ่มก็เริ่มด้วยพื้นฐานเท่าๆ กัน",
      "โกงความรัก ให้ไปไม่เคยได้คืนกลับมา ทั้งที่หมดทั้งตัวทั้งใจให้ไอดอล",
      "ผมหายใจทางจู๋ครับ",
      "ร่องกระดุมมันมีสเน่ห์ของมันอยู่ มีลวดลายที่ซุกซ่อนอยู่ภายใต้ช่องว่างระหว่างเม็ดกระดุมทั้งสองนั้น ก่อให้เกิดมิติใหม่ ที่สร้างความอัศจรรย์ใจแก่ผู้สังเกต",
      "ชีวิตทุกชีวิตมันก็มี purpose ทั้งนั้น ดูแซลมอนสิ ต้องว่ายทวนน้ำกลับไปบ้านที่เกิดมาตั้งแต่เด็ก กลับไปตายเพื่อสืบสายพันธุ์ต่อไป",
      "ข้ามิได้พึงใจในรสชาติสุรา แต่ข้าพึงใจในบรรยากาศของการร่ำนารีเคล้าสุรา",
      "โรคระบาดยังไงละหมาดก็ขาดไม่ได้",
      "ในวันนึงที่ไอดอลรุ่นที่เราชอบทยอยแกรดไปแต่งงาน ท้ายที่สุดเวลาก็ช่วยเยียวยาหัวใจโอตะได้ พลางมองฟตซแล้วคิดถึงวันเวลาที่ได้จับมือกัน ก็ถือเป็นเรื่องราวดีๆ เรื่องนึงในชีวิต",
      "ก็คนไทยดันเอาสาวนมเร้กมาเป็นแม่คนเยอะยังไงล่ะ แทนที่จะเลือกคนนมใหญ่ๆ",
      "ไม่มีผญ รสน้ำบาปมันเฝื่อน",
      "ชักว่าวในอวกาศ แล้วลอยไปทั่ว ราดหน้าผญได้มั้ย",
      "มนุษย์เกิดมาเป็นแสนปี ร่างการปรับเปลี่ยนมากมาย แต่ก็ยังมาตามไอดอล",
      "แล้วเส้นผมคือสิ่งที่บ่งบอกคุณค่าของผู้หญิงหรอคะ ไอร่พวกเครื่องจักรข่มขืนเอ่ย",
      "สายน้ำไม่เคยไหลย้อนกลับ อายุก็เป็นหนึ่งในนั้น และน้ำหนักก็เช่นกัน",
      "สร้างหน้าอกขึ้นมาดึงดูดเพศชายพ่อง เรียนชีวะประเทศไหนมา การ mating ไม่เกี่ยวเหี้ยไรกับการที่มีหน้าอกเลยไอสัด สัตว์ประเภทอื่นไม่เห็นต้องมีมันก็ดึงดูดกันได้ ถ้าจะบอกว่ามีแนวโน้มว่ามีหน้าอกใหญ่ขึ้นเพราะการคัดสรรก็อีกเรื่อง",
      "มึงไม่รู้หรอกว่าเด็กเอ็นถูกกดทับทางสังคม เศรษฐกิจ การเมืองในโลกทุนนิยมขนาดไหน ทั้งยังต้องเจอกับแนวคิดเก่าๆ ตั้งแต่สมัยยุคหินที่ว่าชายเป็นใหญ่อีก",
      "ผู้ชายยังให้เกียรติผญด้วยการไม่ตกเบ็ดเลย",
      "แล้วยังไงต่อ ดอกไม้ก็คือดอกไม้ หมู่ภมรมาตอมก็ไม่ได้ทำให้คุณค่าหายไป ซ้ำยิ่งตอกย้ำความน่าหลงไหลในเกสรนั้น",
      "มันคือแอลกอฮอล์ที่กลั่นบริสุทธิ์เลยว่ะ เวลาไปจับมือไอดอล",
      "หลับตาฝันอ้ายจั๊งได้กอด ยามคึดฮอดได้แต่หรอยมอง ไร้วาสนาได้เป็นเจ้าของดาวนั่น",
      "เมาเหล้าหรือเมารักก็โง่เหมือนกัน ต่างกันเพียงใด หากใจเราใกล้กัน",
      "ปลาเพิ่งรู้ว่ามีท้องฟ้านอกจากหนองน้ำหรอ",
      "พวกเมาลาเกอร์กรรมกร ได้นอนข้างๆ ก็ขนลุก",
      "ตาบอดทางกาย ก็ดีกว่าตาบอดทางใจ เพราะรักคำเดียว",
      "ตอนมึงเป็นสเปิร์มมึงได้ยินเสียงของพระผู้เป็นเจ้าหรอวะ",
      "คิดซะว่าผู้หญิงก็เหมือนสายน้ำ เวลามักจะไม่รอท่า วันละคนกว่าจะถึงคนที่ใช่ก็อาจจะโรยราไปก่อนแล้ว",
      "กูบอกแล้วว่าบางทีคนเราก็อาบน้ำเพื่อเข้าสังคม",
      "แหงนมองไปบนฟ้า เห็นเป็นหมอกขาว ไม่รู้ว่าหมอกอะไร ทั้งที่ไม่ใช่หน้าหนาว",
      "ปีเดียวสำหรับผู้หญิงมันก็นานแล้ว",
      "หนาวเนื้อห่มเนื้อจึ่งหายหนาว ดูดเนื้อได้เนื้อจึ่งอิ่มท้อง",
      "ผมไม่ได้ฆ่า แต่เป็นทานให้ผญยากไร้โปรตีน",
      "บันทึกควยไรไร้สาระสัด",
      "ผ่านชีวิตมาชื่นชมโลกสวยได้เพียงสิบห้าปี",
      "กูควรไปอีกครั้งว่ะ ดิสนี้มีแต่พวกโอชิรุ่นสองอยากให้รุ่นหนึ่งตายๆ ไปให้หมดเหมือนที่พรี่ผม OX48 กล่าวไว้จริงๆ",
      "เมื่อไรจะเลิกหน้าด้านวงไอดอลอ๊บไสไม้ขี้แอ๊บ ขอโทษที่มะลิ้งกิ้งก่องสะดึ้กสะดุ่ย",
      "ยุ่ง",
      "ดอกไม้มันโตตามธรรมชาติ ผลไม้สุกงอมตามฤดู ใยเราถึงต้องเร่งปฏิกริยาของมัน ไม่ใช่เพื่อตอบสนองทุนนิยมหรอกหรือ",
      "ไม่ค่อยไรอะ กูมันคนไร้หัวใจ",
      "หมับไปก็เจอแต่โพลีเอสเตอร์ แทนที่จะเป็นไขมันตามธรรมชาติ",
      "คนเราเลือกเกิดไม่ได้ แต่เลือกโอชิเมมได้",
      "อย่างน้อยไอดอลก็สอนให้เรารู้จักคำว่ารักแล้ว ตายไปจะเสียดายอะไรอีก",
      "อีโก้แรงไปบางทีมันก็ไม่ดีว่ะ กูก็พยายามเพลาๆ บ้างแล้ว",
      "พวกบอกว่าดูก่อนคือพวกไม่มีใจให้เพื่อนเกินร้อย ตัดมันออก",
      "กะหรี่ก็มีชีวิต กะหรี่ก็มีหัวใจ ไปเที่ยวกะหรี่กันมั้ย ไปดำดูปะการัง",
      "กูว่ากินฉี่่ก็ปกตินะ เห็นในเอวีบ่อยๆ",
      "ขี้เปียกก็กินให้",
      "จิตวิญญาณโอตะคุมันร่ำร้อง ข้าพเจ้ามิได้ชมชอบการจับมือ แต่หลงไหลในบรรยากาศงานจับมือยังไงเล่า",
      "ผมขยะดีมีปุ๋ยอีเอ็มราดแล้ว อุดมด้วยจุลินทรีย์",
      "นั่งจิบเบียร์บนโซฟาหนังราคาถูกแล้วดูผู้หญิงนั่งอยู่ในตู้เหมือนแผงหมู",
      "เบื่อแล้วชักดาบอยากโดนชักดอ",
      "หลังสู้ฝ้าหน้าสู้นม",
      "แฟนกูถามกูว่าเกิดมาทำไมละ",
      "จะสมเพชพวกโดนไอดอลหลอกหรือพวกที่ไม่เคยโดนไอดอลบอกรักดี",
      "งานคุไม่ขาดช่วยชาติไม่เคย",
      "คนเราเลือกเกิดไม่ได้ แต่เลือกบุทูช็อตได้",
      "เมืองรถม้า พี่ก็อยากเย็ดท่าม้ากับน้องนาง หีก่อบๆ",
      "เน็ตสองขีด โชคดีของพวกมึง",
      "ชีวิตก็แค่นี้แหละ มึงอย่าให้ธรรมเนียมมาบั่นทอนความตั้งใจได้ ท้องก่อนแต่งมันก็คือความรักเหมือนกัน แถมได้แต้มต่อส่วนลด",
      "ปีนึงกูหล่อได้แค่ 12 วันหรอวะ",
      "ความรู้สึกตอนที่ได้ลิ้มรสนมเด็กมันก็เหมือนตอนที่ซาตานในคราบงูยุยงให้อดัมลิ้มรสแอปเปิลในสวนต้องห้ามนั่นแหละ ในพลันใดนั่นปัญญาก็บังเกิด",
      "ผมเทพ simp ทุกคนต้องคารวะ",
      "ก็แค่ชายธรรมดาคนนึงที่ถือแดรี่ควีนคว่ำถ้วย ไม่ได้พิเศษอะไร",
      "เลิกเรียกผมว่าเสี่ยเถอะคับ ผมก็แค่ขี้เมาคนนึงที่ใจกว้างจนเบียดบังปัจจัยอื่นๆ",
      "ชะตาผมไม่ได้มีเพื่อถูกทิ้งครับ มีแต่ผมที่เคี้ยวอ้อยแล้วถุยซากทิ้ง",
      "อยากได้หมอยเมมมาใส่ล็อคเก็ตตะกรุด"
    ];
    this.setState({
      advice: quotes[Math.floor(Math.random() * quotes.length)],
    });
  };

  render() {
    const { advice } = this.state;

    return (
      <div className="app">
        <div className="card">
          <h1 className="heading">{this.state.advice}</h1>
          <button className="button" onClick={this.fetchAdvice}>
            <span>Give Me Advice</span>
          </button>
        </div>
      </div>
    );
  }
}

export default App;
